module.exports = __webpack_public_path__ + "static/img/cont61 (1).5469b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont61 (1).jpg
// module id = Mbjx
// module chunks = 0